import Color from 'ts-color-class';

export class VisualHelper {
  /**
   * Return 'white' or 'black' text color depending on background color
   * @param {string} bgColor
   * @return {'white' | 'black'}
   */
  public static textColorBg(bgColor: string): 'white' | 'black' {
    return VisualHelper.isDark(bgColor) ? 'white' : 'black';
  }

  /**
   * Check if color can be described as dark
   * @param {string} color
   * @return {boolean}
   */
  public static isDark(color: string): boolean {
    const c = new Color(color);
    // ? magic numbers from
    // https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
    return c.getRed() * 0.299 + c.getGreen() * 0.587 + c.getBlue() * 0.114 <= 186;
  }
}
